export type ThemeChoice = 'light' | 'dark' | 'system'

export function getTheme(): ThemeChoice {
  try {
    const t = localStorage.getItem('esm-theme')
    return t === 'light' || t === 'dark' ? t : 'system'
  } catch {
    return 'system'
  }
}

export function setTheme(t: ThemeChoice): void {
  try {
    if (t === 'system') localStorage.removeItem('esm-theme')
    else localStorage.setItem('esm-theme', t)
  } catch {
    /* storage unavailable: the choice lasts for this page only */
  }
  if (t === 'system') delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = t
}

export function isDark(): boolean {
  const t = document.documentElement.dataset.theme
  if (t) return t === 'dark'
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}
